import { render, staticRenderFns } from "./kw_label_row.vue?vue&type=template&id=2cda3cb2&scoped=true&"
import script from "./kw_label_row.vue?vue&type=script&lang=js&"
export * from "./kw_label_row.vue?vue&type=script&lang=js&"
import style0 from "./kw_label_row.vue?vue&type=style&index=0&id=2cda3cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cda3cb2",
  null
  
)

component.options.__file = "kw_label_row.vue"
export default component.exports